import { LOADING, ANNOUNCEMENTS, PAGE_TYPE, RESET_KEY, } from './types';
export var setLoadingRedux = function (payload) { return ({
    type: LOADING,
    payload: payload,
}); };
export var setPageTypeRedux = function (payload) { return ({
    type: PAGE_TYPE,
    payload: payload,
}); };
export var setResetKeyRedux = function (payload) { return ({
    type: RESET_KEY,
    payload: payload,
}); };
export var setAnnouncementsRedux = function (payload) { return ({
    type: ANNOUNCEMENTS,
    payload: payload,
}); };
